import type { ChangelogEntry } from "../types";

/**
 * Betalingsdatoen på PO-fakturaer var tidspunktet synken kjørte, ikke når
 * fakturaen ble gjort opp. Nå brukes PowerOffice sitt tidspunkt for siste
 * saldoendring.
 */
export const FAKTURA_BETALINGSDATO_2026_10: ChangelogEntry = {
  id: "2026-10-26-faktura-betalingsdato",
  date: "2026-10-26",
  title: "Betalingsdatoen på fakturaer er når de ble gjort opp",
  summary: "Betalte fakturaer fikk datoen synken kjørte. Nå får de tidspunktet saldoen i PowerOffice gikk til null.",
  sections: [
    {
      heading: "Fakturering",
      minRole: "admin",
      items: [
        {
          title: "Riktig betalingsdato fra PowerOffice",
          kind: "rettet",
          body: "De fleste betalte fakturaene hadde samme betalingsdato, dagen en full synk ble kjørt. Nå lagres tidspunktet saldoen i PowerOffice gikk til null. PowerOffice har ikke noe eget felt for betalingsdato, så datoen følger bokføringen av innbetalingen.",
        },
        {
          title: "Fakturadato også på importerte fakturaer",
          kind: "rettet",
          body: "Over 300 eldre fakturaer manglet fakturadato fordi PowerOffice ikke hadde ordredato på dem. Nå brukes bilagsdatoen når ordredatoen mangler, så de vises med dato og havner i riktig periode på Faktura-siden.",
        },
        {
          title: "Betalingsdato når du holder over Betalt",
          kind: "nytt",
          body: "På Faktura-siden viser merket Betalt betalingsdatoen når du holder musepekeren over det, eller går til det med Tab.",
        },
      ],
    },
  ],
};
